// Remembers the account chosen for the most recent import so the picker can
// preselect it next time the tenant has more than one account (L0-U14 item 2,
// ADR 0031). Single-account tenants don't need this -- their sole account is
// always preselected. Stored client-side only; tolerant of storage errors and
// missing/empty values (returns null rather than throwing).

const STORAGE_KEY = "lastImportAccountId";

export function readLastImportAccount(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value !== null && value.length > 0 ? value : null;
  } catch {
    return null;
  }
}

export function writeLastImportAccount(accountId: string): void {
  if (typeof window === "undefined" || accountId === "") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, accountId);
  } catch {
    // ignore -- a remembered default is a convenience, not a correctness need.
  }
}
